import { type ComponentPropsWithoutRef, type ElementType, type ReactNode } from "react";
import classNames from "classnames";

import classes from "./PageTitle.module.less";

type Props<T extends ElementType> = ComponentPropsWithoutRef<T> & {
  tag?: T;
  children?: ReactNode;
};

export const PageTitle = <T extends ElementType = "h1">(props: Props<T>) => {
  const { className, tag = "h1", ...rest } = props;

  const cls = classNames(classes.title, className);
  const Tag = tag;

  return <Tag className={cls} {...rest} />;
};
